/**
 * Sentry’s features help you identify and debug errors and give you all
 * the insight to decide when to fix or roll back. When things go to hell,
 * you’ll have help fighting fires.
 */

window.Sentry = require('@sentry/browser');

window.Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN
});

window.Sentry.configureScope(function (scope) {
    // Set tags
    scope.setTag("locale", navigator.language);

    // set context
    let data = window.__DATA_ || {};

    scope.setExtra('session', data.session);
    scope.setExtra('errors', data.errors);

    // Set user data if available.
    scope.setUser(data._user);
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js